import { enableActivityTracking, newTracker, setUserId, addGlobalContexts as trackerAddGlobalContexts, removeGlobalContexts as trackerRemoveGlobalContexts, trackPageView, trackSelfDescribingEvent } from '@snowplow/browser-tracker';
export default class WebTracker {
    _globalContexts = {};
    constructor(namespace, appID, environment, endpoint){
        this.namespace = namespace;
        const cookieDomain = environment === 'prod' ? '.hudl.com' : '.thorhudl.com';
        this._rawTracker = newTracker(namespace, endpoint, {
            appId: appID,
            cookieDomain,
            discoverRootDomain: false,
            stateStorageStrategy: 'localStorage',
            contexts: {
                webPage: true
            }
        });
    }
    setUserID(userID) {
        // Not using null coalescing here because js-video-playback can't parse it
        setUserId(userID ? userID : null, [
            this.namespace
        ]);
        return Promise.resolve();
    }
    trackSelfDescribingEvent(event, contexts) {
        trackSelfDescribingEvent({
            event: event,
            context: contexts
        }, [
            this.namespace
        ]);
        return Promise.resolve();
    }
    trackScreenViewEvent() {
        throw new Error('trackScreenViewEvent method not applicable on Web');
    }
    trackPageViewEvent(title, contexts) {
        trackPageView({
            title,
            context: contexts
        }, [
            this.namespace
        ]);
        return Promise.resolve();
    }
    trackPagePings(minimumVisitLength, heartbeatDelay) {
        enableActivityTracking({
            minimumVisitLength,
            heartbeatDelay
        });
        return Promise.resolve();
    }
    async addGlobalContexts(tag, contexts) {
        await this.removeGlobalContexts(tag);
        trackerAddGlobalContexts(contexts, [
            this.namespace
        ]);
        this._globalContexts[tag] = contexts;
        return Promise.resolve();
    }
    removeGlobalContexts(tag) {
        const contextsToRemove = this._globalContexts[tag];
        if (contextsToRemove) {
            trackerRemoveGlobalContexts(contextsToRemove, [
                this.namespace
            ]);
        }
        this._globalContexts[tag] = undefined;
        return Promise.resolve();
    }
}

//# sourceMappingURL=WebTracker.js.map